import {
  APPLICATION_ACTIONS_TYPES,
  GUEST_ACTIONS_TYPES,
  INVITATION_ACTIONS_TYPES,
  REGISTRATION_LINK_ACTIONS_TYPES,
  TARGET_ACTIONS,
} from "../constants/bulkActionTypes";

export type SelectedTargetType = (typeof TARGET_ACTIONS)[number]["value"] | "";

export type ApplicationActionsTypes =
  (typeof APPLICATION_ACTIONS_TYPES)[number]["value"];

export type InvitationActionsTypes =
  (typeof INVITATION_ACTIONS_TYPES)[number]["value"];

export type InviteesActionsTypes =
  (typeof REGISTRATION_LINK_ACTIONS_TYPES)[number]["value"];

export type GuestActionsTypes = (typeof GUEST_ACTIONS_TYPES)[number]["value"];

export type SelectedActionType =
  | ApplicationActionsTypes
  | InvitationActionsTypes
  | GuestActionsTypes
  | InviteesActionsTypes
  | "";

export enum CheckUsersStatus {
  no_check = "no_check",
  Approve_All = "approve_application",
  Pending_Review = "pending_application",
  send_invitation = "send_invitation",
  reset_invitation = "reset_invitation",
  no_invitation = "no_invitation",
  delete_guests = "delete_guests",
  change_user_type = "change_user_type",
}

export type CheckUsersStatusTypeKey = keyof typeof CheckUsersStatus;

export enum ActionTypeView {
  // this views used to show view that related to action type
  Approve_All = "Application_Approve",
  Pending_Review = "Application_Pending",
  Create_Applications = "Application_Create",
  create = "Invitation_Create",
  send_invitation = "Invitation_Send",
  reset_invitation = "Invitation_Remove",
  confirm_invitation = "Invitation_Accept",
  decline_invitation = "Invitation_Reject",
  delete_guests = "Guest_Delete",
  edit_user_groups = "Edit_User_Groups",
  change_user_type = "Change_User_Type",
  send_registration_link = "Send_Registration_Link",
  send_email = "Send_Email",
  // this views used to show view that not related to any action
  Invitation_Create_After_Send = "Invitation_Create_After_Send",
  Invitation_Send_After_Create = "Invitation_Send_After_Create",
  InitialState = "InitialState",
}

export type ActionTypeViewTypeKeys = keyof typeof ActionTypeView;

export type ActionTypeViewType =
  (typeof ActionTypeView)[keyof typeof ActionTypeView];

export type BulkActionComponentsType = {
  [K in ActionTypeViewType]?: JSX.Element | null;
};
